export default [
    {
        path: 'deployments',
        name: 'deployments-master-data',
        meta: {
            modules: ['deployment'],
            authentication_required: true,
            authorization_required: ['modules.deployments'],
            translate: (t) => {
                return t('menu_points.deployment').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'applications',
                name: 'applications',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.applications.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.applications').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-applications-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-applications-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.applications.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.applications').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/applications/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-application-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.application.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::applications.application', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/applications/item.vue')
                    },
                    {
                        path: ':id(\\d+)/install',
                        name: 'deployments-application-install',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.instances.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::instances.instance', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/applications/install.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-application-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.application.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::applications.application', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/applications/item.vue')
                    }
                ]
            },
            {
                path: 'environments',
                name: 'environments',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.environments.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.environments').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-environments-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-environments-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environments.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.environments').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/environments/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-environment-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environment.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::environments.environment', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/environments/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-environment-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environment.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::environments.environment', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/environments/item.vue')
                    }
                ]
            },
            {
                path: 'environment-settings',
                name: 'environment-settings',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.environment_settings.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.environment_settings').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-environment-settings-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-environment-settings-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environment_settings.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.environment_settings').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/environment-settings/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-environment-setting-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environment_setting.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::environment_settings.environment_setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/environment-settings/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-environment-setting-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.environment_setting.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::environment_settings.environment_setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/environment-settings/item.vue')
                    }
                ]
            },
            {
                path: 'instances',
                name: 'instances',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.instances.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.instances').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-instances-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-instances-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.instances.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.instances').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/instances/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-instance-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.instance.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::instances.instance', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/instances/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-instance-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.instance.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::instances.instance', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/instances/item.vue')
                    }
                ]
            },
            {
                path: 'deployments',
                name: 'deployments',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.deployments.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.deployments').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-deployments-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-deployments-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.deployments.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.deployments').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/deployments/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-deployment-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.deployment.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::deployments.deployment', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/deployments/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-deployment-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.deployment.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::deployments.deployment', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/deployments/item.vue')
                    }
                ]
            },
            {
                path: 'required-settings',
                name: 'required-settings',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.required_settings.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.required_settings').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-required-settings-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-required-settings-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.required_settings.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.required_settings').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/required-settings/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-required-setting-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.required_setting.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::required_settings.required_setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/required-settings/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-required_setting-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.required_setting.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::required_settings.required_setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/required-settings/item.vue')
                    }
                ]
            },
            {
                path: 'settings',
                name: 'settings',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.settings.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.settings').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-settings-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-settings-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.settings.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.settings').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/settings/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-setting-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.setting.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::settings.setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/settings/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-setting-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.setting.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::settings.setting', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/settings/item.vue')
                    }
                ]
            },
            {
                path: 'servers',
                name: 'servers',
                meta: {
                    modules: ['deployment'],
                    authentication_required: true,
                    authorization_required: ['roles.servers.view'],
                    translate: (t) => {
                        return t('menu_points.deployments.servers').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'deployments-servers-list'},
                children: [
                    {
                        path: '',
                        name: 'deployments-servers-list',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.servers.view'],
                            translate: (t) => {
                                return t('menu_points.deployments.servers').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/deployments/servers/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'deployments-server-create',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.server.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('deployments::servers.server', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/servers/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'deployments-server-update',
                        meta: {
                            modules: ['deployment'],
                            authentication_required: true,
                            authorization_required: ['roles.server.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('deployments::servers.server', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/deployments/servers/item.vue')
                    }
                ]
            }
        ]
    }
];